/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_No_Upcoming_GamesInputs */

const th_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีเกมที่กำลังจะมาถึง`)
};

const en_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming games.`)
};

const ja_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`予定されている試合はありません。`)
};

const zh_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有即将开始的比赛。`)
};

const es_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay próximos partidos.`)
};

const pt_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo próximo.`)
};

const id_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pertandingan mendatang.`)
};

const fr_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match à venir.`)
};

const tl_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang paparating na laro.`)
};

const vi_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có trận sắp tới.`)
};

const ko_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예정된 경기가 없습니다.`)
};

const de_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine kommenden Spiele.`)
};

const ru_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предстоящих матчей нет.`)
};

const tr_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaklaşan maç yok.`)
};

const it_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita in arrivo.`)
};

const pl_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak nadchodzących meczów.`)
};

const uk_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найближчих матчів немає.`)
};

const hi_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई आगामी मैच नहीं।`)
};

const ar_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مباريات قادمة.`)
};

const ms_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perlawanan akan datang.`)
};

const bn_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আসন্ন কোনও খেলা নেই।`)
};

const zh_tw2_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有即將到來的比賽。`)
};

const zh_hk2_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有即將到來的比賽。`)
};

const ur_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی آنے والا میچ نہیں۔`)
};

const fa_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی پیشِ‌رویی نیست.`)
};

const sw_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna michezo inayokuja.`)
};

const nl_home_no_upcoming_games = /** @type {(inputs: Home_No_Upcoming_GamesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen komende wedstrijden.`)
};

/**
* | output |
* | --- |
* | "No upcoming games." |
*
* @param {Home_No_Upcoming_GamesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const home_no_upcoming_games = /** @type {((inputs?: Home_No_Upcoming_GamesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_No_Upcoming_GamesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_home_no_upcoming_games(inputs)
	if (locale === "ja") return ja_home_no_upcoming_games(inputs)
	if (locale === "zh") return zh_home_no_upcoming_games(inputs)
	if (locale === "es") return es_home_no_upcoming_games(inputs)
	if (locale === "pt") return pt_home_no_upcoming_games(inputs)
	if (locale === "id") return id_home_no_upcoming_games(inputs)
	if (locale === "fr") return fr_home_no_upcoming_games(inputs)
	if (locale === "tl") return tl_home_no_upcoming_games(inputs)
	if (locale === "vi") return vi_home_no_upcoming_games(inputs)
	if (locale === "ko") return ko_home_no_upcoming_games(inputs)
	if (locale === "de") return de_home_no_upcoming_games(inputs)
	if (locale === "ru") return ru_home_no_upcoming_games(inputs)
	if (locale === "tr") return tr_home_no_upcoming_games(inputs)
	if (locale === "it") return it_home_no_upcoming_games(inputs)
	if (locale === "pl") return pl_home_no_upcoming_games(inputs)
	if (locale === "uk") return uk_home_no_upcoming_games(inputs)
	if (locale === "hi") return hi_home_no_upcoming_games(inputs)
	if (locale === "ar") return ar_home_no_upcoming_games(inputs)
	if (locale === "ms") return ms_home_no_upcoming_games(inputs)
	if (locale === "bn") return bn_home_no_upcoming_games(inputs)
	if (locale === "zh-TW") return zh_tw2_home_no_upcoming_games(inputs)
	if (locale === "zh-HK") return zh_hk2_home_no_upcoming_games(inputs)
	if (locale === "ur") return ur_home_no_upcoming_games(inputs)
	if (locale === "fa") return fa_home_no_upcoming_games(inputs)
	if (locale === "sw") return sw_home_no_upcoming_games(inputs)
	if (locale === "nl") return nl_home_no_upcoming_games(inputs)
	return en_home_no_upcoming_games(inputs)
});